<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :category-filter-func="filterItem"
      :category-list="tabList"
      :entity-name="$t('AttributeGroup')"
      :icon="'mdi-heart'"
      :model="AttributeGroup"
    >
      <template #item.attrubuteCount="{item}">
        <v-btn
          color="primary"
          elevation="0"
          small
          @click.stop="showAttributeFor(item)"
        >
          <div
            class="hideMore"
            style="max-width: 90px"
          >
            {{ $t('editAttribute') }}
          </div>
        </v-btn>
      </template>
      <template #footer>
        <v-dialog
          v-model="helpDialog"
          max-width="400px"
        >
          <v-card>
            <v-card-title>{{ $t('useInfo') }}</v-card-title>
            <v-card-text>
              <div class="text-h4">
                {{ $t('welcomeAG') }}👏
              </div>
              <div class="text-body-1 mt-4">
                <p v-html="$t('agHint1')"/>
                <p>
                  {{ $t('agHint2') }}
                </p>
                <p>
                  {{ $t('agHint3') }}
                </p>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center pb-4">
              <v-btn
                color="primary"
                elevation="0"
                @click="read"
              >
                {{ $t('iUnderStand') }}
              </v-btn>
            </v-card-actions>
          </v-card>
          <template/>
        </v-dialog>
        <v-btn
          class="ml-2"
          outlined
          style="background: white"
          @click="helpDialog=true"
        >
          <v-icon
            class="mt-1"
            left
          >
            mdi-information-outline
          </v-icon>
          {{ $t('help') }}
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
  import { IkDataTable, IkNiceDialog } from 'metaflow-js'
  import AttributeGroup from '../../../../../model/dish/AttributeGroup'
  import Attribute from '../../../../../model/dish/Attribute'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import SortFragment from '@/views/AadenPages/dishes/dish/widget/SortFragment'
  import { Remember } from '@/GlobalSettings'
  import i18n from '../../../../../i18n'

  export default {
    components: {
      SortFragment,
      PageHeader,
      IkDataTable,
      NiceDialog: IkNiceDialog,
    },
    data: function () {
      return ({
        selectedAIdList: [],
        helpDialog: null,
        attributeList: [],
        showGroupAttribute: [],
        AttributeGroup: AttributeGroup,
        Attribute: Attribute,
        showAttributeDialog: false,
        filter: null,
        currentAttributeGroup: null,
        tabList: [{
          name: i18n.t('flavors_and_specifications'), // 口味和规格
          id: 1,
        }, {
          name: i18n.t('addIngredients'), // 加料
          id: 2,
        }],
      })
    },
    mounted () {
      if (!Remember.readAgHint) {
        this.helpDialog = true
      }
    },
    methods: {
      read () {
        Remember.readAgHint = true
        this.helpDialog = false
      },
      filterItem (item, currentTab) {
        return item.required === (currentTab.id === 1)
      },
      showAttributeFor (item) {
        this.$router.push('/dishes/attributeByGroup/' + item.id)
      },
    },
  }
</script>
